// import { createSharedPathnamesNavigation } from "next-intl/navigation";
// import { locales, localePrefix } from "./i18n/routing";

// export const { Link, redirect, usePathname, useRouter } = createSharedPathnamesNavigation({ locales, localePrefix });
import { createNavigation } from "next-intl/navigation";

export const { Link, redirect, useRouter, usePathname } = createNavigation();
